
































import { Prop, Component, Vue } from 'vue-property-decorator'

/**
 * Provides button functionality, but not styling.
 */
@Component({})
export default class OzBaseButton extends Vue {
  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  click(event: MouseEvent): void {
    /**
     * Click event
     * @property {MouseEvent} event click event
     */
    this.$emit('click', event)
  }

  handleSpaceKey(event: KeyboardEvent): void {
    // Anchor elements with roles set to ‘button’ can only be activated with the ‘enter’ key,
    // whereas a button element would be triggered by both ‘space’ and ‘enter’ keys.
    // Adding a space keypress event listener and calling this method should ensure
    // that the element triggers the same event that a click, or pressing the ‘enter’ key
    // would (mouse click event) and execute the default behavior.
    const SPACE_KEYCODE = event.code === 'Space'
    if (this.href && SPACE_KEYCODE) {
      event.preventDefault()
      // Prevent default scrolling behaviour on anchor tags
      const linkButton = this.$el as HTMLAnchorElement
      linkButton.click()
    }
  }
}
